import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const put = (id, mappingConfig) =>
  requestsTemplates.put(mainPath, `/mapping_fields/${id}`, mappingConfig);
